module.exports = __webpack_public_path__ + "9341187f40a63f1614681c0fcc1894bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/macha-panel-768.jpg
// module id = 476
// module chunks = 0